document.getElementById('login-button').addEventListener('click', function(event) {
    event.preventDefault();

    // Gather input data
    const email = document.getElementById('email-login').value;
    const password = document.getElementById('password-login').value;

    // Validate input fields
    if (!email || !password) {
        document.getElementById('form-message').innerText = 'Všechna pole jsou povinné!';
        return;
    }

    // Add loading state to the button
    const loginButton = document.getElementById('login-button');
    loginButton.innerHTML = 'Přihlašuji...';

    // Create JSON object
    const data = {
        email: email,
        password: password
    };

    // Send the request via Fetch API to the new endpoint
    fetch('/a/api/club/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        if (response.ok) {
            return response.json(); // Parse JSON response
        } else {
            throw new Error('Network response was not ok');
        }
    })
    .then(data => {
        // Remove loading state
        loginButton.innerHTML = 'Přihlásit se';

        // Process the response from the server
        if (data.status === 'ok' && data.customer_hash) {
            // Store customer_hash in local storage
            localStorage.setItem('customer_hash', data.customer_hash);
            // Redirect to /pages/club?page=vyhody
            window.location.href = '/pages/club?page=vyhody';
        } else if (data.status === 'wrong_password') {
            document.getElementById('form-message').innerText = 'Neprávné heslo!';
        } else if (data.status === 'not_found') {
            document.getElementById('form-message').innerText = 'Zákazník nebyl nalezen!';
        } else {
            // Fallback for any unexpected response
            document.getElementById('form-message').innerText = 'Neznámá chyba, zkuste to prosím později.';
        }
    })
    .catch(error => {
        console.error('Error:', error);
        document.getElementById('form-message').innerText = 'Něco se pokazilo, zkuste to prosím znova později.';
        // Remove loading state
        loginButton.innerHTML = 'Přihlásit se';
    });
});
